import { Menu, Transition } from "@headlessui/react";

import { Fragment, useRef } from "react";
import { useTranslation } from "react-i18next";

import { IconCheck } from "@/components/icons";
import { IconChevronDown } from "@/components/icons/main.icons";

import { usePatchProfile } from "@/hooks/api/user.hooks";
import { useStaffLangs } from "@/hooks/ui/useStaffLangs";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const langs = useStaffLangs();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const profileId = localStorage.getItem("splay:profileId");
  const { mutate } = usePatchProfile();

  const handleMouseLeave = (close: () => void) => {
    timerRef.current = setTimeout(() => {
      close();
    }, 300);
  };

  const clearCloseTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const updateLanguage = (lang: string) => {
    i18n.changeLanguage(lang);

    if (profileId) {
      mutate({
        user_id: +profileId,
        //@ts-ignore
        data: {
          interface_lang: lang,
        },
      });
    }
  };

  return (
    <Menu as="div" className="relative max-md:hidden">
      {({ open, close }) => (
        <div onMouseEnter={clearCloseTimer} onMouseLeave={() => handleMouseLeave(close)}>
          <Menu.Button className="group flex cursor-pointer items-center gap-2">
            <div className="size-6 rounded-full">
              <img
                alt="language"
                src={i18n.language === "ru" ? "/images/russian.svg" : "/images/uzbek.svg"}
                className="h-full w-full"
              />
            </div>
            <p className="text-on-surface transition-colors group-hover:text-on-primary">
              {i18n.language === "ru" ? "Рус" : "O'zb"}
            </p>
            <IconChevronDown className="size-6 stroke-on-surface transition-colors group-hover:stroke-white" />
          </Menu.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-75"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Menu.Items
              static
              className="absolute right-0 z-[1000] mt-[14px] flex w-[240px] flex-col items-start rounded-xl bg-surface-bright py-2"
              onMouseEnter={clearCloseTimer}
              onMouseLeave={() => handleMouseLeave(close)}
              modal={false}
            >
              {langs.map((lang) => (
                <Menu.Item key={lang.value} as={Fragment}>
                  <button
                    className="flex w-full items-center justify-between px-4 py-3 hover:bg-surface-container-high"
                    onClick={() => {
                      updateLanguage(lang.value);
                    }}
                  >
                    <span className="flex items-center gap-3">
                      <img src={lang.image} alt={lang.title} /> {lang.title}
                    </span>
                    {i18n.language === lang.value && (
                      <span>
                        <IconCheck className="size-6 stroke-on-primary" />
                      </span>
                    )}
                  </button>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </div>
      )}
    </Menu>
  );
};

export default LanguageSwitcher;
